/**
 * HTML 인앱메시지를 렌더링하기 위한 iframe과 그 wrapper element를 관리합니다.
 * DOM과 관련된 인터페이스만 제공하고, 그 외 비즈니스 로직은 처리하지 않습니다.
 */
export class HtmlInAppMessageDOMManager {
  private readonly WRAPPER_CLASS_NAME = "hackle-iam-html__wrapper"
  private readonly IFRAME_CLASS_NAME = "hackle-iam-html__iframe"

  private $wrapper: HTMLDivElement | null = null
  private $iframe: HTMLIFrameElement | null = null

  createElement(): [HTMLDivElement, HTMLIFrameElement] {
    this.$wrapper = document.createElement("div")
    this.$iframe = document.createElement("iframe")

    this.$wrapper.classList.add(this.WRAPPER_CLASS_NAME)
    this.$iframe.classList.add(this.IFRAME_CLASS_NAME)

    return [this.$wrapper, this.$iframe]
  }

  attachToDOM(): void {
    if (!this.$wrapper || !this.$iframe) return
    const wrapper = this.$wrapper
    const iframe = this.$iframe

    if (!wrapper.contains(iframe)) {
      wrapper.appendChild(iframe)
    }

    if (!wrapper.parentNode) {
      document.body.appendChild(wrapper)
    }
  }

  removeElement(): void {
    if (this.$wrapper) {
      this.$wrapper.remove()
      this.$wrapper = null
      this.$iframe = null
    }
  }

  onLoad(callback: () => void) {
    if (this.$iframe) {
      this.$iframe.onload = () => {
        callback()
      }
    }
  }

  getIframeContentWindow(): Window | null {
    return this.$iframe?.contentWindow ?? null
  }
}
